import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
} from '../../api';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Block Container',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/opr',
      },
      {
        text: 'Block Container',
        href: '/adm/opr/container/block-container',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_block_container',
    sortDesc: true,
    fields: [
      {
        key: 'code_block',
        sortable: true,
      },
      {
        key: 'date_block',
        label: 'Tanggal',
      },
      {
        key: 'prefix',
        label: 'Prefix',
      },
      {
        key: 'number',
        label: 'Number',
      },
      {
        key: 'container',
        label: 'Container',
      },
      {
        key: 'type_block',
        label: 'Block Container',
      },
      {
        key: 'remark_block',
        label: 'Keterangan',
      },
      {
        key: 'status_block',
        label: 'Status',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    detail: false,
    form: {
      id_container: '',
      remark_block: '',
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changeBlockContainer(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchBlockContainer(context, params = null) {
    let result = await ApiGetRequest(`opr/block-container`, params);
    return !result.error ? result.data.object : [];
  },

  async searchContainerStock({ commit }, payload = null) {
    commit('changeBlockContainer', {
      loading: true,
    });

    let result = await ApiGetRequest(`opr/container/stock`, payload);
    commit('changeBlockContainer', {
      loading: false,
    });

    if (!result.error) {
      return !result.error ? result.data.object : [];
    }

    return false;
  },

  async getListBlockContainer({ commit, state }) {
    commit('changeBlockContainer', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`opr/block-container`, params);
    commit('changeBlockContainer', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailBlockContainer({ commit, state }, payload = null) {
    commit('changeBlockContainer', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`opr/block-container/${payload.id}`);
    commit('changeBlockContainer', {
      loading: false,
      form: {
        ...data.form,
        ...result.data.object,
      },
    });

    return result.error ? false : true;
  },

  async createBlockContainer({ commit, state, dispatch }) {
    commit('changeBlockContainer', {
      loading: true,
    });

    let result = await ApiPostRequest(`opr/block-container`, state.data.form);
    commit('changeBlockContainer', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateBlockContainer({ commit, state, dispatch }, payload = null) {
    commit('changeBlockContainer', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `opr/block-container/${payload.id}`,
      state.data.form
    );

    commit('changeBlockContainer', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteBlockContainer({ commit, dispatch }, payload = null) {
    commit('changeBlockContainer', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`opr/block-container/${payload.id}`);
    commit('changeBlockContainer', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
